
import React from 'react';

const TacticalLoader: React.FC<{ size?: 'sm' | 'md' | 'lg' | 'xl' }> = ({ size = 'md' }) => {
    const sizeClasses = {
        sm: 'w-8 h-8',
        md: 'w-16 h-16',
        lg: 'w-32 h-32',
        xl: 'w-64 h-64'
    };

    return (
        <div className={`relative flex items-center justify-center ${sizeClasses[size]}`}>
            {/* Outer Ring */}
            <div className="absolute inset-0 border-2 border-gray-700/50 rounded-full"></div>

            {/* Spinning Segments */}
            <div className="absolute inset-0 border-2 border-transparent border-t-arsenal-red border-r-arsenal-red rounded-full animate-spin-slow"></div>

            {/* Inner Reticle */}
            <div className="absolute inset-[25%] border border-arsenal-red/50 rounded-full flex items-center justify-center">
                <div className="w-1 h-1 bg-arsenal-red rounded-full animate-pulse"></div>
            </div>

            {/* Crosshairs */}
            <div className="absolute top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-arsenal-red/50 to-transparent"></div>
            <div className="absolute left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-arsenal-red/50 to-transparent"></div>
        </div>
    );
};

export default TacticalLoader;
